import script from "./RegisterEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterEmail.vue?vue&type=script&setup=true&lang=js"

import "./RegisterEmail.vue?vue&type=style&index=0&id=58b15202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b15202"]])

export default __exports__